exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{width:100%}div{background:#fdf667;font-size:1.35rem;text-align:center;color:#000;padding:.3rem 0;line-height:1.5rem}div.top{padding:1.8rem 0 .3rem}div>a{color:#2a52b5;padding:0 .2rem}.u-hide-mobile{display:inline}@media only screen and (max-width:568px){:host(.is-mobile) div{font-size:1.4rem;line-height:1.7rem}:host(.is-mobile) div.top{padding:3rem 0 .5rem}:host(.is-mobile) div:last-of-type{padding:0 0 1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./cdiv/en-US/js/cdiv-footer-links/cdiv-footer-links.css
// module id = 14
// module chunks = 14